import React from "react";
import { Card } from "views/components/ui/Card";
import { AlertCircle, CheckCircle, XCircle, AlertTriangle } from "lucide-react";

const StatsOverview = ({
    pendingCount,
    approvedCount,
    rejectedCount,
    errorCount,
}) => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
            <Card className="p-6">
                <div className="flex items-center gap-3">
                    <AlertCircle className="h-6 w-6 text-yellow-600" />
                    <div>
                        <h3 className="text-lg font-medium">Pending Review</h3>
                        <p className="text-2xl font-bold">{pendingCount}</p>
                    </div>
                </div>
            </Card>
            <Card className="p-6">
                <div className="flex items-center gap-3">
                    <CheckCircle className="h-6 w-6 text-green-600" />
                    <div>
                        <h3 className="text-lg font-medium">Approved Tools</h3>
                        <p className="text-2xl font-bold">{approvedCount}</p>
                    </div>
                </div>
            </Card>
            <Card className="p-6">
                <div className="flex items-center gap-3">
                    <XCircle className="h-6 w-6 text-red-600" />
                    <div>
                        <h3 className="text-lg font-medium">Rejected Tools</h3>
                        <p className="text-2xl font-bold">{rejectedCount}</p>
                    </div>
                </div>
            </Card>
            <Card className="p-6">
                <div className="flex items-center gap-3">
                    <AlertTriangle className="h-6 w-6 text-orange-600" />
                    <div>
                        <h3 className="text-lg font-medium">
                            Processing Error
                        </h3>
                        <p className="text-2xl font-bold">{errorCount}</p>
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default StatsOverview;
